import { gql } from 'graphql-request';

import withFragments from 'utils/graphql';

import CTABlock from 'fragments/CTABlock';
import { RichTextBlock } from 'fragments/GenericBlocks';
import Logo from 'fragments/Logo';

export default withFragments(
  gql`
    query($id: Int, $contentType: String!, $token: String!) {
      page(id: $id, contentType: $contentType, token: $token) {
        id
        url
        title
        slug
        seoTitle
        seoDescription
        ... on ServiceIndex {
          metaImage {
            url
          }
          metaTitle
          metaDescription
          logo {
            ...Logo
          }
          body {
            id
            blockType
            ...CTABlock
            ...RichTextBlock
            ... on ServiceCategoryBlock {
              serviceCategories {
                id
                name
                services {
                  id
                  title
                  slug
                  url
                }
              }
            }
          }
          breadcrumbs {
            url
            title
          }
        }
      }
    }
  `,
  { CTABlock, RichTextBlock, Logo },
);
